// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/images/bnwscaffolding.png';
import { FaFacebookF, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src={logo} alt="B&W Scaffolding" className="footer-logo" />
          <h3>B&W Scaffolding</h3>
          <p>
            📞 <a href="tel:+447801753368">+44 7801 753368</a><br />
            ✉️ <a href="mailto:info@b.wscaffoldingco@gmail.com">info@b.wscaffoldingco@gmail.com</a>
          </p>
          <div className="footer-social">
            <a href="https://www.facebook.com/bwscaffoldingco" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://wa.me/441234567890" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <h4>Pages</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/hiring">We’re Hiring</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} B&W Scaffolding. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
